type CourseFromType = 'course' | 'exam';

export class DegreeCompletionBlockCourse {
  static numberFilter: ng.IFilterNumber;

  credits: number = 0;
  displayCredits: string = '0';
  type: CourseFromType = 'course';
  courses: string[];
  exams: string[];
  display: string = '';

  constructor(block_course: any) {
    _.merge(this, block_course);
    this.displayCredits = DegreeCompletionBlockCourse.numberFilter(
      DegreeCompletionBlockCourse.numberFilter(this.credits, 2)
    );
    this.display = (this.type === 'course' ? this.courses : this.exams).join('<br />');
  }

  static build(block_course: any): DegreeCompletionBlockCourse {
    return new DegreeCompletionBlockCourse(block_course);
  }
}

angular
  .module('capability-ng-transfer')
  .factory(
    'ngDegreeCompletionBlockCourseBuilder',
    (
      numberFilter: ng.IFilterNumber
    ): typeof DegreeCompletionBlockCourse => {
      DegreeCompletionBlockCourse.numberFilter = numberFilter;
      return DegreeCompletionBlockCourse;
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/degree_completion_block_course_builder.ts